module.exports = __webpack_public_path__ + "img/32.20c73e61.jpg";